// @ts-strict-ignore
import { Route } from "@dashboard/components/Router";
import { WindowTitle } from "@dashboard/components/WindowTitle";
import React from "react";
import { RouteComponentProps, Switch } from "react-router-dom";

import { sduiPath } from "./urls";
import SduiPage from "./views/SduiPage";

export const SduiSection: React.FC<RouteComponentProps<any>> = () => (
  <>
    <WindowTitle title="Server-Driven UI & Dynamic Theming" />
    <Switch>
      <Route exact path={sduiPath} component={SduiPage} />
    </Switch>
  </>
);

export default SduiSection;
